/*
 *  Licensed under the EUPL, Version 1.2 or – as soon they will be approved by
 the European Commission - subsequent versions of the EUPL (the "Licence");
 You may not use this work except in compliance with the Licence.
 You may obtain a copy of the Licence at:

 https://joinup.ec.europa.eu/software/page/eupl

 Unless required by applicable law or agreed to in writing, software
 distributed under the Licence is distributed on an "AS IS" basis,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the Licence for the specific language governing permissions and
 limitations under the Licence. */

import { getIn } from "../utils";
import {
  darkColor as defaultDarkColor,
  getEnvColor as defaultEnvColor,
  primary as defaultPrimary,
  primaryDarker as defaultPrimaryDarker,
  getTheme as getDefaultTheme,
  getV0Theme as getV0DefaultTheme,
} from "./themes/default/defaultTheme";

const themeLogos = import.meta.glob("/src/config/themes/*/logo.png", {
  eager: true,
});
const defaultLogo = themeLogos["/src/config/themes/default/logo.png"].default;

// Eagerly load every theme's index.js the same way logos are loaded
const themeModules = import.meta.glob("/src/config/themes/*/index.js", {
  eager: true,
});

const getThemeModule = () => {
  const theme = import.meta.env.VITE_THEME;
  if (!theme) return null;
  const mod = themeModules[`/src/config/themes/${theme}/index.js`];
  if (!mod) {
    throw new Error(`Theme "${theme}" not found in /src/config/themes`);
  }
  return mod;
};

export const getTiamatEnv = () => {
  return getIn(window, ["config", "tiamatEnv"], "development");
};

export const getEnvColor = (env) => {
  const mod = getThemeModule();
  return mod ? mod.getEnvColor(env) : defaultEnvColor(env);
};

export const getV0Theme = () => {
  const mod = getThemeModule();
  return mod ? mod.getV0Theme() : getV0DefaultTheme();
};

export const getTheme = () => {
  const mod = getThemeModule();
  return mod ? mod.getTheme() : getDefaultTheme();
};

export const getLogo = () => {
  if (import.meta.env.VITE_THEME) {
    return themeLogos[
      `/src/config/themes/${import.meta.env.VITE_THEME}/logo.png`
    ].default;
  } else {
    return defaultLogo;
  }
};

export const getPrimaryColor = () => {
  const mod = getThemeModule();
  return mod ? mod.primary : defaultPrimary;
};

export const getHeaderColor = () => {
  const mod = getThemeModule();
  return mod ? mod.getEnvColor() : defaultEnvColor();
};

export const getDarkColor = () => {
  const mod = getThemeModule();
  return mod ? mod.darkColor : defaultDarkColor;
};

export const getPrimaryDarkerColor = () => {
  const mod = getThemeModule();
  return mod ? mod.primaryDarker : defaultPrimaryDarker;
};
